import moment from "moment"
const getListYear = () => {
  const currentYear = moment().year()
  const lower = currentYear - 5
  const upper = currentYear + 5

  const list = []
  for (let i = lower; i <= upper; i++) {
    list.push({
      value: i,
      label: i
    })
  }
  return list
}

const getListMonth = () => {
  const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  const list = []
  for (const i of months) {
    list.push({
      value: `${i} 月`,
      label: `${i} 月`
    })
  }
  return list
}


export const ProductionSummaryUtil = {
  getListMonth,
  getListYear
}